import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=c1b95526&"
import script from "./VModal.vue?vue&type=script&lang=ts&"
export * from "./VModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports